// @ts-nocheck
import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import {
  LayoutDashboard,
  CalendarDays,
  Users,
  Hotel,
  Megaphone,
  Upload,
  BarChart3,
  LogOut,
} from 'lucide-react';
import { Button } from '@/components/ui/button';

const navItems = [
  { label: 'Dashboard', to: '/hotel-portal', icon: LayoutDashboard, end: true },
  { label: 'My Events', to: '/hotel-portal/events', icon: CalendarDays },
  { label: 'Hotel Management', to: '/hotel-portal/hotels', icon: Hotel },
  { label: 'Team Tracker', to: '/hotel-portal/tracker', icon: Users },
  { label: 'Outreach Center', to: '/hotel-portal/outreach', icon: Megaphone },
  { label: 'Booking Upload', to: '/hotel-portal/upload', icon: Upload },
  { label: 'Reports', to: '/hotel-portal/reports', icon: BarChart3 },
];

const linkClass = (isActive: boolean) =>
  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
    isActive
      ? 'bg-white/15 text-white'
      : 'text-white/70 hover:bg-white/10 hover:text-white'
  }`;

const HotelPortalLayout: React.FC = () => {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();

  const displayName = profile
    ? [profile.first_name, profile.last_name].filter(Boolean).join(' ') || profile.name || 'Hotel Partner'
    : 'Hotel Partner';

  const handleLogout = async () => {
    await signOut();
    navigate('/auth/login');
  };

  return (
    <div className="flex min-h-screen w-full flex-col md:flex-row">
      {/* Sidebar (desktop) / top bar (mobile) */}
      <aside className="flex flex-col bg-[#0d4f4f] text-white shrink-0 md:w-64">
        <div className="px-5 py-4 md:py-6 border-b border-white/10">
          <h2 className="text-lg font-bold tracking-wide">Hotel Partner Portal</h2>
        </div>

        <nav className="flex-1 py-2 md:py-4 px-3 flex md:flex-col gap-1 overflow-x-auto md:overflow-visible">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => linkClass(isActive)}
            >
              <item.icon className="h-4 w-4 shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Bottom user section */}
        <div className="mt-auto border-t border-white/10 p-4 flex md:flex-col items-center md:items-stretch justify-between gap-3">
          <p className="text-sm font-medium truncate">{displayName}</p>
          <Button
            variant="ghost"
            size="sm"
            className="justify-start text-white/70 hover:text-white hover:bg-white/10"
            onClick={handleLogout}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 bg-background p-4 md:p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default HotelPortalLayout;
